import { createActions, handleActions } from 'redux-actions'

// helpers
import { loadingError, startLoading } from './_helpers'

export const BULK_ASSIGN_TRAINING_TEMPLATE = 'ace/BULK_ASSIGN_TRAINING_TEMPLATE'
export const BULK_ASSIGN_TRAINING_TEMPLATE_FAILURE = 'ace/BULK_ASSIGN_TRAINING_TEMPLATE_FAILURE'
export const BULK_ASSIGN_TRAINING_TEMPLATE_SUCCESS = 'ace/BULK_ASSIGN_TRAINING_TEMPLATE_SUCCESS'

export const FETCH_TRAINING_TEMPLATE = 'ace/FETCH_TRAINING_TEMPLATE'
export const FETCH_TRAINING_TEMPLATE_FAILURE = 'ace/FETCH_TRAINING_TEMPLATE_FAILURE'
export const FETCH_TRAINING_TEMPLATE_SUCCESS = 'ace/FETCH_TRAINING_TEMPLATE_SUCCESS'

export const FETCH_TRAINING_TEMPLATES = 'ace/FETCH_TRAINING_TEMPLATES'
export const FETCH_TRAINING_TEMPLATES_FAILURE = 'ace/FETCH_TRAINING_TEMPLATES_FAILURE'
export const FETCH_TRAINING_TEMPLATES_SUCCESS = 'ace/FETCH_TRAINING_TEMPLATES_SUCCESS'

export const UPDATE_TRAINING_TEMPLATE = 'ace/UPDATE_TRAINING_TEMPLATE'
export const UPDATE_TRAINING_TEMPLATE_FAILURE = 'ace/UPDATE_TRAINING_TEMPLATE_FAILURE'
export const UPDATE_TRAINING_TEMPLATE_SUCCESS = 'ace/UPDATE_TRAINING_TEMPLATE_SUCCESS'

export const DELETE_TRAINING_TEMPLATE = 'ace/DELETE_TRAINING_TEMPLATE'
export const DELETE_TRAINING_TEMPLATE_FAILURE = 'ace/DELETE_TRAINING_TEMPLATE_FAILURE'
export const DELETE_TRAINING_TEMPLATE_SUCCESS = 'ace/DELETE_TRAINING_TEMPLATE_SUCCESS'

export const CREATE_SIDE_HUSTLE = 'ace/CREATE_SIDE_HUSTLE'
export const CREATE_SIDE_HUSTLE_FAILURE = 'ace/CREATE_SIDE_HUSTLE_FAILURE'
export const CREATE_SIDE_HUSTLE_SUCCESS = 'ace/CREATE_SIDE_HUSTLE_SUCCESS'

export const CREATE_TRAINING_RECORD = 'ace/CREATE_TRAINING_RECORD'
export const CREATE_TRAINING_RECORD_FAILURE = 'ace/CREATE_TRAINING_RECORD_FAILURE'
export const CREATE_TRAINING_RECORD_SUCCESS = 'ace/CREATE_TRAINING_RECORD_SUCCESS'

export const CREATE_TRAINING_TEMPLATE = 'ace/CREATE_TRAINING_TEMPLATE'
export const CREATE_TRAINING_TEMPLATE_FAILURE = 'ace/CREATE_TRAINING_TEMPLATE_FAILURE'
export const CREATE_TRAINING_TEMPLATE_SUCCESS = 'ace/CREATE_TRAINING_TEMPLATE_SUCCESS'

export const CREATE_WORK_RECORD = 'ace/CREATE_WORK_RECORD'
export const CREATE_WORK_RECORD_FAILURE = 'ace/CREATE_WORK_RECORD_FAILURE'
export const CREATE_WORK_RECORD_SUCCESS = 'ace/CREATE_WORK_RECORD_SUCCESS'

export const DELETE_SIDE_HUSTLE = 'ace/DELETE_SIDE_HUSTLE'
export const DELETE_SIDE_HUSTLE_FAILURE = 'ace/DELETE_SIDE_HUSTLE_FAILURE'
export const DELETE_SIDE_HUSTLE_SUCCESS = 'ace/DELETE_SIDE_HUSTLE_SUCCESS'

export const DELETE_TRAINING_RECORD = 'ace/DELETE_TRAINING_RECORD'
export const DELETE_TRAINING_RECORD_FAILURE = 'ace/DELETE_TRAINING_RECORD_FAILURE'
export const DELETE_TRAINING_RECORD_SUCCESS = 'ace/DELETE_TRAINING_RECORD_SUCCESS'

export const DELETE_WORK_RECORD = 'ace/DELETE_WORK_RECORD'
export const DELETE_WORK_RECORD_FAILURE = 'ace/DELETE_WORK_RECORD_FAILURE'
export const DELETE_WORK_RECORD_SUCCESS = 'ace/DELETE_WORK_RECORD_SUCCESS'

export const FETCH_SIDE_HUSTLE = 'ace/FETCH_SIDE_HUSTLE'
export const FETCH_SIDE_HUSTLE_FAILURE = 'ace/FETCH_SIDE_HUSTLE_FAILURE'
export const FETCH_SIDE_HUSTLE_SUCCESS = 'ace/FETCH_SIDE_HUSTLE_SUCCESS'

export const FETCH_SIDE_HUSTLES = 'ace/FETCH_SIDE_HUSTLES'
export const FETCH_SIDE_HUSTLES_FAILURE = 'ace/FETCH_SIDE_HUSTLES_FAILURE'
export const FETCH_SIDE_HUSTLES_SUCCESS = 'ace/FETCH_SIDE_HUSTLES_SUCCESS'

export const FETCH_TRAINING_RECORD = 'ace/FETCH_TRAINING_RECORD'
export const FETCH_TRAINING_RECORD_FAILURE = 'ace/FETCH_TRAINING_RECORD_FAILURE'
export const FETCH_TRAINING_RECORD_SUCCESS = 'ace/FETCH_TRAINING_RECORD_SUCCESS'

export const FETCH_TRAINING_RECORDS = 'ace/FETCH_TRAINING_RECORDS'
export const FETCH_TRAINING_RECORDS_FAILURE = 'ace/FETCH_TRAINING_RECORDS_FAILURE'
export const FETCH_TRAINING_RECORDS_SUCCESS = 'ace/FETCH_TRAINING_RECORDS_SUCCESS'

export const FETCH_WORK_RECORD = 'ace/FETCH_WORK_RECORD'
export const FETCH_WORK_RECORD_FAILURE = 'ace/FETCH_WORK_RECORD_FAILURE'
export const FETCH_WORK_RECORD_SUCCESS = 'ace/FETCH_WORK_RECORD_SUCCESS'

export const FETCH_WORK_RECORDS = 'ace/FETCH_WORK_RECORDS'
export const FETCH_WORK_RECORDS_FAILURE = 'ace/FETCH_WORK_RECORDS_FAILURE'
export const FETCH_WORK_RECORDS_SUCCESS = 'ace/FETCH_WORK_RECORDS_SUCCESS'

export const UPDATE_SIDE_HUSTLE = 'ace/UPDATE_SIDE_HUSTLE'
export const UPDATE_SIDE_HUSTLE_FAILURE = 'ace/UPDATE_SIDE_HUSTLE_FAILURE'
export const UPDATE_SIDE_HUSTLE_SUCCESS = 'ace/UPDATE_SIDE_HUSTLE_SUCCESS'

export const UPDATE_TRAINING_RECORD = 'ace/UPDATE_TRAINING_RECORD'
export const UPDATE_TRAINING_RECORD_FAILURE = 'ace/UPDATE_TRAINING_RECORD_FAILURE'
export const UPDATE_TRAINING_RECORD_SUCCESS = 'ace/UPDATE_TRAINING_RECORD_SUCCESS'

export const UPDATE_WORK_RECORD = 'ace/UPDATE_WORK_RECORD'
export const UPDATE_WORK_RECORD_FAILURE = 'ace/UPDATE_WORK_RECORD_FAILURE'
export const UPDATE_WORK_RECORD_SUCCESS = 'ace/UPDATE_WORK_RECORD_SUCCESS'

export const SEARCH_ACE_SKILLS = 'ace/SEARCH_ACE_SKILLS'
export const SEARCH_ACE_SKILLS_FAILURE = 'ace/SEARCH_ACE_SKILLS_FAILURE'
export const SEARCH_ACE_SKILLS_SUCCESS = 'ace/SEARCH_ACE_SKILLS_SUCCESS'

export const {
  ace: {
    bulkAssignTrainingTemplate,
    bulkAssignTrainingTemplateFailure,
    bulkAssignTrainingTemplateSuccess,
    fetchTrainingTemplate,
    fetchTrainingTemplateFailure,
    fetchTrainingTemplateSuccess,
    fetchTrainingTemplates,
    fetchTrainingTemplatesFailure,
    fetchTrainingTemplatesSuccess,
    updateTrainingTemplate,
    updateTrainingTemplateFailure,
    updateTrainingTemplateSuccess,
    deleteTrainingTemplate,
    deleteTrainingTemplateFailure,
    deleteTrainingTemplateSuccess,
    createSideHustle,
    createSideHustleFailure,
    createSideHustleSuccess,
    createTrainingRecord,
    createTrainingRecordFailure,
    createTrainingRecordSuccess,
    createTrainingTemplate,
    createTrainingTemplateFailure,
    createTrainingTemplateSuccess,
    createWorkRecord,
    createWorkRecordFailure,
    createWorkRecordSuccess,
    deleteSideHustle,
    deleteSideHustleFailure,
    deleteSideHustleSuccess,
    deleteTrainingRecord,
    deleteTrainingRecordFailure,
    deleteTrainingRecordSuccess,
    deleteWorkRecord,
    deleteWorkRecordFailure,
    deleteWorkRecordSuccess,
    fetchSideHustle,
    fetchSideHustleFailure,
    fetchSideHustleSuccess,
    fetchSideHustles,
    fetchSideHustlesFailure,
    fetchSideHustlesSuccess,
    fetchTrainingRecord,
    fetchTrainingRecordFailure,
    fetchTrainingRecordSuccess,
    fetchTrainingRecords,
    fetchTrainingRecordsFailure,
    fetchTrainingRecordsSuccess,
    fetchWorkRecord,
    fetchWorkRecordFailure,
    fetchWorkRecordSuccess,
    fetchWorkRecords,
    fetchWorkRecordsFailure,
    fetchWorkRecordsSuccess,
    updateSideHustle,
    updateSideHustleFailure,
    updateSideHustleSuccess,
    updateTrainingRecord,
    updateTrainingRecordFailure,
    updateTrainingRecordSuccess,
    updateWorkRecord,
    updateWorkRecordFailure,
    updateWorkRecordSuccess,
    searchAceSkills,
    searchAceSkillsFailure,
    searchAceSkillsSuccess
  }
} = createActions({
  [BULK_ASSIGN_TRAINING_TEMPLATE]: undefined,
  [BULK_ASSIGN_TRAINING_TEMPLATE_FAILURE]: undefined,
  [BULK_ASSIGN_TRAINING_TEMPLATE_SUCCESS]: undefined,

  [FETCH_TRAINING_TEMPLATE]: undefined,
  [FETCH_TRAINING_TEMPLATE_FAILURE]: undefined,
  [FETCH_TRAINING_TEMPLATE_SUCCESS]: undefined,

  [FETCH_TRAINING_TEMPLATES]: undefined,
  [FETCH_TRAINING_TEMPLATES_FAILURE]: undefined,
  [FETCH_TRAINING_TEMPLATES_SUCCESS]: undefined,

  [UPDATE_TRAINING_TEMPLATE]: undefined,
  [UPDATE_TRAINING_TEMPLATE_FAILURE]: undefined,
  [UPDATE_TRAINING_TEMPLATE_SUCCESS]: undefined,

  [DELETE_TRAINING_TEMPLATE]: undefined,
  [DELETE_TRAINING_TEMPLATE_FAILURE]: undefined,
  [DELETE_TRAINING_TEMPLATE_SUCCESS]: undefined,

  [CREATE_SIDE_HUSTLE]: undefined,
  [CREATE_SIDE_HUSTLE_FAILURE]: undefined,
  [CREATE_SIDE_HUSTLE_SUCCESS]: undefined,

  [CREATE_TRAINING_RECORD]: undefined,
  [CREATE_TRAINING_RECORD_FAILURE]: undefined,
  [CREATE_TRAINING_RECORD_SUCCESS]: undefined,

  [CREATE_TRAINING_TEMPLATE]: undefined,
  [CREATE_TRAINING_TEMPLATE_FAILURE]: undefined,
  [CREATE_TRAINING_TEMPLATE_SUCCESS]: undefined,

  [CREATE_WORK_RECORD]: undefined,
  [CREATE_WORK_RECORD_FAILURE]: undefined,
  [CREATE_WORK_RECORD_SUCCESS]: undefined,

  [DELETE_SIDE_HUSTLE]: undefined,
  [DELETE_SIDE_HUSTLE_FAILURE]: undefined,
  [DELETE_SIDE_HUSTLE_SUCCESS]: undefined,

  [DELETE_TRAINING_RECORD]: undefined,
  [DELETE_TRAINING_RECORD_FAILURE]: undefined,
  [DELETE_TRAINING_RECORD_SUCCESS]: undefined,

  [DELETE_WORK_RECORD]: undefined,
  [DELETE_WORK_RECORD_FAILURE]: undefined,
  [DELETE_WORK_RECORD_SUCCESS]: undefined,

  [FETCH_SIDE_HUSTLE]: undefined,
  [FETCH_SIDE_HUSTLE_FAILURE]: undefined,
  [FETCH_SIDE_HUSTLE_SUCCESS]: undefined,

  [FETCH_SIDE_HUSTLES]: undefined,
  [FETCH_SIDE_HUSTLES_FAILURE]: undefined,
  [FETCH_SIDE_HUSTLES_SUCCESS]: undefined,

  [FETCH_TRAINING_RECORD]: undefined,
  [FETCH_TRAINING_RECORD_FAILURE]: undefined,
  [FETCH_TRAINING_RECORD_SUCCESS]: undefined,

  [FETCH_TRAINING_RECORDS]: undefined,
  [FETCH_TRAINING_RECORDS_FAILURE]: undefined,
  [FETCH_TRAINING_RECORDS_SUCCESS]: undefined,

  [FETCH_WORK_RECORD]: undefined,
  [FETCH_WORK_RECORD_FAILURE]: undefined,
  [FETCH_WORK_RECORD_SUCCESS]: undefined,

  [FETCH_WORK_RECORDS]: undefined,
  [FETCH_WORK_RECORDS_FAILURE]: undefined,
  [FETCH_WORK_RECORDS_SUCCESS]: undefined,

  [UPDATE_SIDE_HUSTLE]: undefined,
  [UPDATE_SIDE_HUSTLE_FAILURE]: undefined,
  [UPDATE_SIDE_HUSTLE_SUCCESS]: undefined,

  [UPDATE_TRAINING_RECORD]: undefined,
  [UPDATE_TRAINING_RECORD_FAILURE]: undefined,
  [UPDATE_TRAINING_RECORD_SUCCESS]: undefined,

  [UPDATE_WORK_RECORD]: undefined,
  [UPDATE_WORK_RECORD_FAILURE]: undefined,
  [UPDATE_WORK_RECORD_SUCCESS]: undefined,

  [SEARCH_ACE_SKILLS]: undefined,
  [SEARCH_ACE_SKILLS_FAILURE]: undefined,
  [SEARCH_ACE_SKILLS_SUCCESS]: undefined
})

const initialState = {
  paginatedSideHustles: {
    sideHustles: [],
    sideHustlesCount: 0,
    sideHustlesPageCount: 0
  },
  paginatedTrainingRecords: {
    trainingRecords: [],
    trainingRecordsCount: 0,
    trainingRecordsPageCount: 0
  },
  paginatedWorkRecords: {
    workRecords: [],
    workRecordsCount: 0,
    workRecordsPageCount: 0
  },
  singleSideHustle: {},
  singleTrainingRecord: {},
  singleTrainingTemplate: {},
  singleWorkRecord: {},
  trainingTemplates: [],
  trainingTemplatesCount: 0,
  trainingTemplatesPageCount: 0,
  skillResults: [],
  skillsQuery: '',
  isSkillsLoading: false,
  isLoading: false,
  isSubmitting: false,
  isError: false
}

export default handleActions(
  {
    [BULK_ASSIGN_TRAINING_TEMPLATE]: state => ({ ...state, isSubmitting: true }),
    [BULK_ASSIGN_TRAINING_TEMPLATE_FAILURE]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      isError: true,
      errorMessage: payload
    }),
    [BULK_ASSIGN_TRAINING_TEMPLATE_SUCCESS]: state => ({
      ...state,
      isSubmitting: false,
      isError: false
    }),

    [FETCH_TRAINING_TEMPLATE]: startLoading,
    [FETCH_TRAINING_TEMPLATE_FAILURE]: loadingError,
    [FETCH_TRAINING_TEMPLATE_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      singleTrainingTemplate: payload
    }),

    [FETCH_TRAINING_TEMPLATES]: startLoading,
    [FETCH_TRAINING_TEMPLATES_FAILURE]: loadingError,
    [FETCH_TRAINING_TEMPLATES_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isError: false,
      isSuccess: true,
      trainingTemplates: (payload && payload.trainingTemplates) || [],
      trainingTemplatesCount: (payload && payload.trainingTemplatesCount) || 0,
      trainingTemplatesPageCount: (payload && payload.pageCount) || 0
    }),

    [UPDATE_TRAINING_TEMPLATE]: state => ({ ...state, isSubmitting: true }),
    [UPDATE_TRAINING_TEMPLATE_FAILURE]: state => ({ ...state, isSubmitting: false }),
    [UPDATE_TRAINING_TEMPLATE_SUCCESS]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      trainingTemplates: [payload, ...state.trainingTemplates.filter(o => o.id !== payload.id)]
    }),

    [DELETE_TRAINING_TEMPLATE]: state => ({ ...state, isLoading: true }),
    [DELETE_TRAINING_TEMPLATE_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_TRAINING_TEMPLATE_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      trainingTemplates: state.trainingTemplates.filter(o => o.id !== payload.trainingTemplateId)
    }),

    [CREATE_SIDE_HUSTLE]: state => ({ ...state, isSubmitting: true }),
    [CREATE_SIDE_HUSTLE_FAILURE]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      isError: true,
      errorMessage: payload
    }),
    [CREATE_SIDE_HUSTLE_SUCCESS]: state => ({
      ...state,
      isSubmitting: false,
      isError: false
    }),

    [CREATE_TRAINING_RECORD]: state => ({ ...state, isSubmitting: true }),
    [CREATE_TRAINING_RECORD_FAILURE]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      isError: true,
      errorMessage: payload
    }),
    [CREATE_TRAINING_RECORD_SUCCESS]: state => ({
      ...state,
      isSubmitting: false,
      isError: false
    }),

    [CREATE_TRAINING_TEMPLATE]: state => ({ ...state, isSubmitting: true }),
    [CREATE_TRAINING_TEMPLATE_FAILURE]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      isError: true,
      errorMessage: payload
    }),
    [CREATE_TRAINING_TEMPLATE_SUCCESS]: state => ({
      ...state,
      isSubmitting: false,
      isError: false
    }),

    [CREATE_WORK_RECORD]: state => ({ ...state, isSubmitting: true }),
    [CREATE_WORK_RECORD_FAILURE]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      isError: true,
      errorMessage: payload
    }),
    [CREATE_WORK_RECORD_SUCCESS]: state => ({
      ...state,
      isSubmitting: false,
      isError: false
    }),

    [DELETE_SIDE_HUSTLE]: state => ({ ...state, isLoading: true }),
    [DELETE_SIDE_HUSTLE_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_SIDE_HUSTLE_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      sideHustles: state.paginatedSideHustles.sideHustles.filter(o => o.id !== payload.sideHustleId)
    }),

    [DELETE_TRAINING_RECORD]: state => ({ ...state, isLoading: true }),
    [DELETE_TRAINING_RECORD_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_TRAINING_RECORD_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      trainingRecords: state.paginatedTrainingRecords.trainingRecords.filter(
        o => o.id !== payload.recordId
      )
    }),

    [DELETE_WORK_RECORD]: state => ({ ...state, isLoading: true }),
    [DELETE_WORK_RECORD_FAILURE]: state => ({ ...state, isLoading: false }),
    [DELETE_WORK_RECORD_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      workRecords: state.paginatedWorkRecords.workRecords.filter(o => o.id !== payload.recordId)
    }),

    [FETCH_SIDE_HUSTLE]: startLoading,
    [FETCH_SIDE_HUSTLE_FAILURE]: loadingError,
    [FETCH_SIDE_HUSTLE_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      singleSideHustle: payload
    }),

    [FETCH_SIDE_HUSTLES]: startLoading,
    [FETCH_SIDE_HUSTLES_FAILURE]: loadingError,
    [FETCH_SIDE_HUSTLES_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        isSuccess: true,
        hasSubmitted: false,
        errorMessage: null
      }

      newState.paginatedSideHustles.sideHustlesPageCount = payload.pageCount || 0
      newState.paginatedSideHustles.sideHustlesCount = payload.sideHustlesCount || 0
      newState.paginatedSideHustles.sideHustles = payload.sideHustles || []

      return newState
    },

    [FETCH_TRAINING_RECORD]: startLoading,
    [FETCH_TRAINING_RECORD_FAILURE]: loadingError,
    [FETCH_TRAINING_RECORD_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      singleTrainingRecord: payload
    }),

    [FETCH_TRAINING_RECORDS]: startLoading,
    [FETCH_TRAINING_RECORDS_FAILURE]: loadingError,
    [FETCH_TRAINING_RECORDS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        isSuccess: true,
        hasSubmitted: false,
        errorMessage: null
      }

      newState.paginatedTrainingRecords.trainingRecordsPageCount = payload.pageCount || 0
      newState.paginatedTrainingRecords.trainingRecordsCount = payload.trainingRecordsCount || 0
      newState.paginatedTrainingRecords.trainingRecords = payload.trainingRecords || []

      return newState
    },

    [FETCH_WORK_RECORD]: startLoading,
    [FETCH_WORK_RECORD_FAILURE]: loadingError,
    [FETCH_WORK_RECORD_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      singleWorkRecord: payload
    }),

    [FETCH_WORK_RECORDS]: startLoading,
    [FETCH_WORK_RECORDS_FAILURE]: loadingError,
    [FETCH_WORK_RECORDS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        isSuccess: true,
        hasSubmitted: false,
        errorMessage: null
      }

      newState.paginatedWorkRecords.workRecordsPageCount = payload.pageCount || 0
      newState.paginatedWorkRecords.workRecordsCount = payload.workRecordsCount || 0
      newState.paginatedWorkRecords.workRecords = payload.workRecords || []

      return newState
    },

    [UPDATE_SIDE_HUSTLE]: state => ({ ...state, isSubmitting: true }),
    [UPDATE_SIDE_HUSTLE_FAILURE]: state => ({ ...state, isSubmitting: false }),
    [UPDATE_SIDE_HUSTLE_SUCCESS]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      sideHustles: [
        payload,
        ...state.paginatedSideHustles.sideHustles.filter(o => o.id !== payload.id)
      ]
    }),

    [UPDATE_TRAINING_RECORD]: state => ({ ...state, isSubmitting: true }),
    [UPDATE_TRAINING_RECORD_FAILURE]: state => ({ ...state, isSubmitting: false }),
    [UPDATE_TRAINING_RECORD_SUCCESS]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      trainingRecords: [
        payload,
        ...state.paginatedTrainingRecords.trainingRecords.filter(o => o.id !== payload.id)
      ]
    }),

    [UPDATE_WORK_RECORD]: state => ({ ...state, isSubmitting: true }),
    [UPDATE_WORK_RECORD_FAILURE]: state => ({ ...state, isSubmitting: false }),
    [UPDATE_WORK_RECORD_SUCCESS]: (state, { payload }) => ({
      ...state,
      isSubmitting: false,
      workRecords: [
        payload,
        ...state.paginatedWorkRecords.workRecords.filter(o => o.id !== payload.id)
      ]
    }),

    [SEARCH_ACE_SKILLS]: (state, { payload }) => ({
      ...state,
      isSkillsLoading: true,
      skillsQuery: payload && payload.s ? payload.s : ''
    }),
    [SEARCH_ACE_SKILLS_FAILURE]: state => ({ ...state, isSkillsLoading: false }),
    [SEARCH_ACE_SKILLS_SUCCESS]: (state, { payload }) => ({
      ...state,
      isSkillsLoading: false,
      skillResults: (payload && payload.skills) || []
    })
  },
  initialState
)
